import { useEffect } from 'react'

interface useInitProps {
  setDataLoaded: Function
  setShowOverlay: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    props.setDataLoaded(true)
    props.setShowOverlay(false)
  }, [])
}

export default useInit
